module.exports = __webpack_public_path__ + "img/Jump Casting53.0d35b216.jpg";